var $ = window.jQuery = require('jquery');
import {
  bus
} from '../../main';
export default {
  name: 'quiz-category',
  components: {},
  props: [],
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {
  $(document).ready(function() {
    $(".hud_circle > .quiz_cont_list_name").on("mouseenter", function() {
      $(this).parents('.hud_circle').addClass("hover_cat");
    });
    $(".hud_circle > .quiz_cont_list_name").on("mouseleave", function() {
      $(this).parents('.hud_circle').removeClass("hover_cat");
    });
  });
  },
  methods: {
    QuizCategoryPopupClose() {
      $(".quizzort_main_wrp").removeClass("popup_active");
      setTimeout(() => {
        bus.$emit('hideQuizCategory', false);
        bus.$emit('hideQuizzortPopupEnabled', false);
        $("body").removeClass("quizzort_popup_active");
      }, 500)
      localStorage.removeItem('quiz');
    },
    QuizShowInstruction() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('hideQuizCategory', false);
      }, 500);
      bus.$emit('showQuizInstruction', true);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 500);
    },
    QuizGameSHow() {
      localStorage.setItem('quiz', btoa('space-exploration'))
      this.QuizShowInstruction();
    },
    QuizGameSHowCs() {
      localStorage.setItem('quiz', btoa('computer-science'))
      this.QuizShowInstruction();
    },
    QuizGameSHowFinance() {
      localStorage.setItem('quiz', btoa('finance'))
      this.QuizShowInstruction();
    },
    QuizGameSHowMachineL() {
      localStorage.setItem('quiz', btoa('machine-learning'));
      this.QuizShowInstruction();

    },
    QuizGameSHowComputationalS() {
      localStorage.setItem('quiz', btoa('computational-science'))
      this.QuizShowInstruction();

    }
  }
}